import { useTheme } from "@mui/material";
import type { FC } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import { PaperworkTypeList } from "web_myplann/Profile/Components/Paperwork/PaperworkTypeList";
import { usePaperworkDocument } from "web_myplann/Profile/Hooks/usePaperworkDocument";
import { MyPlannLoading } from "web_myplann/Shared/Components/MyPlannLoading";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

export const PaperworkAddPage: FC = () => {
	const theme = useTheme();
	const { t } = useResource();
	const navigate = useNavigate();
	const { id } = useParams();
	const { document, isLoading } = usePaperworkDocument(id);

	const defaultRoute = AppRouting.MyPlann.Profile.Paperwork.path();

	if (id && !isLoading && !document) {
		return (
			<Navigate to={AppRouting.MyPlann.Profile.Paperwork.path()} replace />
		);
	}

	const children =
		id && isLoading ? (
			<MyPlannLoading />
		) : (
			<PaperworkTypeList
				selectedTypeId={document?.documentType}
				onSelectType={(type) =>
					navigate(
						id
							? AppRouting.MyPlann.Profile.PaperworkEditForm.path(id, type.id)
							: AppRouting.MyPlann.Profile.PaperworkAddForm.path(type.id),
					)
				}
			/>
		);

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.grey[50]}
			topBar={
				<NavigationHeader
					title={t(
						id
							? Resources.Paperwork.Upload.updateTitle
							: Resources.Paperwork.Upload.title,
					)}
					bgColor={theme.palette.background.appBar}
					defaultRoute={defaultRoute}
					alwaysUseDefaultRoute
				/>
			}
		>
			{children}
		</MyPlannLayout>
	);
};
